export default "__VITE_ASSET__D_nDE9wa__"